import { AutogenModelEdiLoggerSetting, AutogenRowEdiLoggerSetting } from "./autogen/AutogenModelEdiLoggerSetting";

export class ModelEdiLoggerSetting extends AutogenModelEdiLoggerSetting<RowEdiLoggerSetting> {
	constructor() {
		super(RowEdiLoggerSetting);
	}
}

export class RowEdiLoggerSetting extends AutogenRowEdiLoggerSetting {
}